var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#544C40",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 221 256",
    enableBackground: "new 0 0 221 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.613,68.098l24.882-24.882l-5.686-5.641l-5.686-5.641l-19.105,19.06l-19.105,19.06l-9.28-9.28 c-5.095-5.095-9.462-9.28-9.644-9.28c-0.182,0-2.911,2.593-6.095,5.732l-5.777,5.777l14.966,14.966 c8.233,8.233,15.102,14.966,15.284,14.966C72.64,92.98,83.966,81.79,97.613,68.098L97.613,68.098z M207.166,103.194V128 c0,2.559-1.969,4.528-4.528,4.528s-4.528-1.969-4.528-4.528V91.972c0-1.575-0.197-2.953-0.984-4.331 c-1.378-3.347-4.528-5.906-8.072-6.694c-0.591-0.197-1.575-0.197-2.166-0.197v42.722c0,2.559-1.969,4.528-4.528,4.528 s-4.528-1.969-4.528-4.528V69.528c0-1.181-0.197-1.969-0.394-2.953c-0.197-1.181-0.984-2.166-1.575-3.347 c-0.984-1.181-1.772-2.166-3.15-3.15c-0.984-0.591-2.166-1.181-3.347-1.575c-0.591,0-1.575-0.197-2.756-0.197 c-0.591,0-1.575,0-2.166,0.197V2H2.416v189H126.25c4.134,11.419,13.191,20.475,24.806,24.806V254h67.528V114.416 C218.388,108.116,213.466,103.194,207.166,103.194z M150.859,152.806c-2.559,0-4.528-1.969-4.528-4.528v-40.556 c0-6.3-4.922-11.222-11.222-11.222c-6.984,0-11.222,5.212-11.222,11.294v15.875H33.916v9.056h89.972v13.584H33.916v9.056h89.972 v22.444c0,1.575,0.197,2.953,0.197,4.528H11.275V11.056h143.916v58.472v78.75h0.197 C155.388,150.838,153.419,152.806,150.859,152.806z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproval);
export default __webpack_public_path__ + "static/media/approval.fbb16fba5e694a64ea982e9217e20e34.svg";
export { ForwardRef as ReactComponent };